// @ts-nocheck
// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 修改当前用户密码 POST /api/plat/v1/access/change-pwd */
export async function postPlatV1AccessChangePwd(
  body: API.AccessChangePwdReq,
  options?: { [key: string]: any }
) {
  return request<API.AccessChangePwdRes>("/api/plat/v1/access/change-pwd", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取字典信息 GET /api/plat/v1/access/dict */
export async function getPlatV1AccessDict(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1AccessDictParams,
  options?: { [key: string]: any }
) {
  return request<API.AccessDictRes>("/api/plat/v1/access/dict", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取当前角色菜单信息 GET /api/plat/v1/access/menus */
export async function getPlatV1AccessMenus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1AccessMenusParams,
  options?: { [key: string]: any }
) {
  return request<API.AccessMenusRes>("/api/plat/v1/access/menus", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取当前用户详细信息 GET /api/plat/v1/access/profile */
export async function getPlatV1AccessProfile(options?: { [key: string]: any }) {
  return request<API.AccessProfileRes>("/api/plat/v1/access/profile", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取当前用户信息 GET /api/plat/v1/access/self */
export async function getPlatV1AccessSelf(options?: { [key: string]: any }) {
  return request<API.AccessSelfRes>("/api/plat/v1/access/self", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取当前用户可选单位列表 GET /api/plat/v1/access/staff-list */
export async function getPlatV1AccessStaffList(options?: {
  [key: string]: any;
}) {
  return request<API.AccessStaffListRes>("/api/plat/v1/access/staff-list", {
    method: "GET",
    ...(options || {}),
  });
}

/** 切换员工身份 POST /api/plat/v1/access/switch-staff */
export async function postPlatV1AccessSwitchStaff(
  body: API.AccessSwitchStaffReq,
  options?: { [key: string]: any }
) {
  return request<API.AccessSwitchStaffRes>("/api/plat/v1/access/switch-staff", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取系统配置信息 GET /api/plat/v1/access/sys_config */
export async function getPlatV1AccessSysConfig(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1AccessSysConfigParams,
  options?: { [key: string]: any }
) {
  return request<API.AccessSysConfigRes>("/api/plat/v1/access/sys_config", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 修改当前用户信息 POST /api/plat/v1/access/update-profile */
export async function postPlatV1AccessUpdateProfile(
  body: API.AccessUpdateProfileReq,
  options?: { [key: string]: any }
) {
  return request<API.AccessUpdateProfileRes>(
    "/api/plat/v1/access/update-profile",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 激活套餐 POST /api/plat/v1/combo/activate */
export async function postPlatV1ComboActivate(
  body: API.ComboActivateReq,
  options?: { [key: string]: any }
) {
  return request<API.ComboActivateRes>("/api/plat/v1/combo/activate", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 绑定套餐 POST /api/plat/v1/combo/bind */
export async function postPlatV1ComboBind(
  body: API.ComboBindReq,
  options?: { [key: string]: any }
) {
  return request<API.ComboBindRes>("/api/plat/v1/combo/bind", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取下级组织套餐列表 GET /api/plat/v1/combo/children/list */
export async function getPlatV1ComboChildrenList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1ComboChildrenListParams,
  options?: { [key: string]: any }
) {
  return request<API.ComboChildrenListRes>("/api/plat/v1/combo/children/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建套餐 POST /api/plat/v1/combo/create */
export async function postPlatV1ComboCreate(
  body: API.ComboCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.ComboCreateRes>("/api/plat/v1/combo/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除套餐 GET /api/plat/v1/combo/delete */
export async function getPlatV1ComboOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1Combo_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.ComboDeleteRes>("/api/plat/v1/combo/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取套餐详情 GET /api/plat/v1/combo/detail */
export async function getPlatV1ComboDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1ComboDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.ComboDetailRes>("/api/plat/v1/combo/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取套餐列表 GET /api/plat/v1/combo/list */
export async function getPlatV1ComboList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1ComboListParams,
  options?: { [key: string]: any }
) {
  return request<API.ComboListRes>("/api/plat/v1/combo/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择套餐 GET /api/plat/v1/combo/select */
export async function getPlatV1ComboSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1ComboSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.ComboSelectRes>("/api/plat/v1/combo/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新套餐 POST /api/plat/v1/combo/update */
export async function postPlatV1ComboUpdate(
  body: API.ComboUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.ComboUpdateRes>("/api/plat/v1/combo/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询套餐用量 GET /api/plat/v1/combo/usage */
export async function getPlatV1ComboUsage(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1ComboUsageParams,
  options?: { [key: string]: any }
) {
  return request<API.ComboUsageRes>("/api/plat/v1/combo/usage", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 预警走势图 GET /api/plat/v1/dashboard/alert_trend */
export async function getPlatV1DashboardAlertTrend(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DashboardAlertTrendParams,
  options?: { [key: string]: any }
) {
  return request<API.DashboardAlertTrendRes>(
    "/api/plat/v1/dashboard/alert_trend",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 设备分布统计 GET /api/plat/v1/dashboard/device_distribution_stats */
export async function getPlatV1DashboardDeviceDistributionStats(options?: {
  [key: string]: any;
}) {
  return request<API.DashboardDeviceDistributionStatsRes>(
    "/api/plat/v1/dashboard/device_distribution_stats",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 事件统计 GET /api/plat/v1/dashboard/event_stats */
export async function getPlatV1DashboardEventStats(options?: {
  [key: string]: any;
}) {
  return request<API.DashboardEventStatsRes>(
    "/api/plat/v1/dashboard/event_stats",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 网关设备统计 GET /api/plat/v1/dashboard/gateway_device_stats */
export async function getPlatV1DashboardGatewayDeviceStats(options?: {
  [key: string]: any;
}) {
  return request<API.DashboardGatewayDeviceStatsRes>(
    "/api/plat/v1/dashboard/gateway_device_stats",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 国标设备统计 GET /api/plat/v1/dashboard/gb_device_stats */
export async function getPlatV1DashboardGbDeviceStats(options?: {
  [key: string]: any;
}) {
  return request<API.DashboardGbDeviceStatsRes>(
    "/api/plat/v1/dashboard/gb_device_stats",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 最新事件 GET /api/plat/v1/dashboard/latest_events */
export async function getPlatV1DashboardLatestEvents(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DashboardLatestEventsParams,
  options?: { [key: string]: any }
) {
  return request<API.DashboardLatestEventsRes>(
    "/api/plat/v1/dashboard/latest_events",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 组织信息 GET /api/plat/v1/dashboard/org_info */
export async function getPlatV1DashboardOrgInfo(options?: {
  [key: string]: any;
}) {
  return request<API.DashboardOrgInfoRes>("/api/plat/v1/dashboard/org_info", {
    method: "GET",
    ...(options || {}),
  });
}

/** 创建设备型号 POST /api/plat/v1/dev_model/create */
export async function postPlatV1DevModelCreate(
  body: API.DevModelCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.DevModelCreateRes>("/api/plat/v1/dev_model/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除设备型号 GET /api/plat/v1/dev_model/delete */
export async function getPlatV1DevModelOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DevModel_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.DevModelDeleteRes>("/api/plat/v1/dev_model/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取设备型号详情 GET /api/plat/v1/dev_model/detail */
export async function getPlatV1DevModelDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DevModelDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.DevModelDetailRes>("/api/plat/v1/dev_model/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取设备型号列表 GET /api/plat/v1/dev_model/list */
export async function getPlatV1DevModelList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DevModelListParams,
  options?: { [key: string]: any }
) {
  return request<API.DevModelListRes>("/api/plat/v1/dev_model/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择设备型号 GET /api/plat/v1/dev_model/select */
export async function getPlatV1DevModelSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DevModelSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.DevModelSelectRes>("/api/plat/v1/dev_model/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新设备型号 POST /api/plat/v1/dev_model/update */
export async function postPlatV1DevModelUpdate(
  body: API.DevModelUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.DevModelUpdateRes>("/api/plat/v1/dev_model/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建设备供应商 POST /api/plat/v1/dev_vendor/create */
export async function postPlatV1DevVendorCreate(
  body: API.DevVendorCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.DevVendorCreateRes>("/api/plat/v1/dev_vendor/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除设备供应商 GET /api/plat/v1/dev_vendor/delete */
export async function getPlatV1DevVendorOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DevVendor_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.DevVendorDeleteRes>("/api/plat/v1/dev_vendor/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取设备供应商详情 GET /api/plat/v1/dev_vendor/detail */
export async function getPlatV1DevVendorDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DevVendorDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.DevVendorDetailRes>("/api/plat/v1/dev_vendor/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取设备供应商列表 GET /api/plat/v1/dev_vendor/list */
export async function getPlatV1DevVendorList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DevVendorListParams,
  options?: { [key: string]: any }
) {
  return request<API.DevVendorListRes>("/api/plat/v1/dev_vendor/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择设备供应商 GET /api/plat/v1/dev_vendor/select */
export async function getPlatV1DevVendorSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DevVendorSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.DevVendorSelectRes>("/api/plat/v1/dev_vendor/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新设备供应商 POST /api/plat/v1/dev_vendor/update */
export async function postPlatV1DevVendorUpdate(
  body: API.DevVendorUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.DevVendorUpdateRes>("/api/plat/v1/dev_vendor/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建设备网关 POST /api/plat/v1/device_gateway/create */
export async function postPlatV1DeviceGatewayCreate(
  body: API.DeviceGatewayCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayCreateRes>(
    "/api/plat/v1/device_gateway/create",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除设备网关 GET /api/plat/v1/device_gateway/delete */
export async function getPlatV1DeviceGatewayOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceGateway_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayDeleteRes>(
    "/api/plat/v1/device_gateway/delete",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取设备网关详情 GET /api/plat/v1/device_gateway/detail */
export async function getPlatV1DeviceGatewayDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceGatewayDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayDetailRes>(
    "/api/plat/v1/device_gateway/detail",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 下发设备网关 POST /api/plat/v1/device_gateway/dispatch */
export async function postPlatV1DeviceGatewayDispatch(
  body: API.DeviceGatewayDispatchReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayDispatchRes>(
    "/api/plat/v1/device_gateway/dispatch",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取设备网关下发信息 GET /api/plat/v1/device_gateway/dispatch-info */
export async function getPlatV1DeviceGatewayDispatchInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceGatewayDispatchInfoParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayDispatchInfoRes>(
    "/api/plat/v1/device_gateway/dispatch-info",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 回收设备网关下发 POST /api/plat/v1/device_gateway/dispatch-recall */
export async function postPlatV1DeviceGatewayDispatchRecall(
  body: API.DeviceGatewayDispatchRecallReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayDispatchRecallRes>(
    "/api/plat/v1/device_gateway/dispatch-recall",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取设备网关列表 GET /api/plat/v1/device_gateway/list */
export async function getPlatV1DeviceGatewayList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceGatewayListParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayListRes>("/api/plat/v1/device_gateway/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择设备网关 GET /api/plat/v1/device_gateway/select */
export async function getPlatV1DeviceGatewaySelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceGatewaySelectParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewaySelectRes>(
    "/api/plat/v1/device_gateway/select",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 分享设备网关 POST /api/plat/v1/device_gateway/share */
export async function postPlatV1DeviceGatewayShare(
  body: API.DeviceGatewayShareReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayShareRes>(
    "/api/plat/v1/device_gateway/share",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 设备网关分享信息 GET /api/plat/v1/device_gateway/share-infos */
export async function getPlatV1DeviceGatewayShareInfos(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceGatewayShareInfosParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayShareInfosRes>(
    "/api/plat/v1/device_gateway/share-infos",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 回收设备网关分享 POST /api/plat/v1/device_gateway/share-recall */
export async function postPlatV1DeviceGatewayShareRecall(
  body: API.DeviceGatewayShareRecallReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayShareRecallRes>(
    "/api/plat/v1/device_gateway/share-recall",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 更新设备网关 POST /api/plat/v1/device_gateway/update */
export async function postPlatV1DeviceGatewayUpdate(
  body: API.DeviceGatewayUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceGatewayUpdateRes>(
    "/api/plat/v1/device_gateway/update",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建设备终端 POST /api/plat/v1/device_terminal/create */
export async function postPlatV1DeviceTerminalCreate(
  body: API.DeviceTerminalCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalCreateRes>(
    "/api/plat/v1/device_terminal/create",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除设备终端 GET /api/plat/v1/device_terminal/delete */
export async function getPlatV1DeviceTerminalOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceTerminal_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalDeleteRes>(
    "/api/plat/v1/device_terminal/delete",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取设备终端详情 GET /api/plat/v1/device_terminal/detail */
export async function getPlatV1DeviceTerminalDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceTerminalDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalDetailRes>(
    "/api/plat/v1/device_terminal/detail",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 下发设备终端 POST /api/plat/v1/device_terminal/dispatch */
export async function postPlatV1DeviceTerminalDispatch(
  body: API.DeviceTerminalDispatchReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalDispatchRes>(
    "/api/plat/v1/device_terminal/dispatch",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取设备终端下发信息 GET /api/plat/v1/device_terminal/dispatch-info */
export async function getPlatV1DeviceTerminalDispatchInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceTerminalDispatchInfoParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalDispatchInfoRes>(
    "/api/plat/v1/device_terminal/dispatch-info",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 回收设备终端下发 POST /api/plat/v1/device_terminal/dispatch-recall */
export async function postPlatV1DeviceTerminalDispatchRecall(
  body: API.DeviceTerminalDispatchRecallReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalDispatchRecallRes>(
    "/api/plat/v1/device_terminal/dispatch-recall",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取设备终端列表 GET /api/plat/v1/device_terminal/list */
export async function getPlatV1DeviceTerminalList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceTerminalListParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalListRes>(
    "/api/plat/v1/device_terminal/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 选择设备终端 GET /api/plat/v1/device_terminal/select */
export async function getPlatV1DeviceTerminalSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceTerminalSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalSelectRes>(
    "/api/plat/v1/device_terminal/select",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 分享设备终端 POST /api/plat/v1/device_terminal/share */
export async function postPlatV1DeviceTerminalShare(
  body: API.DeviceTerminalShareReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalShareRes>(
    "/api/plat/v1/device_terminal/share",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 设备终端分享信息 GET /api/plat/v1/device_terminal/share-infos */
export async function getPlatV1DeviceTerminalShareInfos(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DeviceTerminalShareInfosParams,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalShareInfosRes>(
    "/api/plat/v1/device_terminal/share-infos",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 回收设备终端分享 POST /api/plat/v1/device_terminal/share-recall */
export async function postPlatV1DeviceTerminalShareRecall(
  body: API.DeviceTerminalShareRecallReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalShareRecallRes>(
    "/api/plat/v1/device_terminal/share-recall",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 更新设备终端 POST /api/plat/v1/device_terminal/update */
export async function postPlatV1DeviceTerminalUpdate(
  body: API.DeviceTerminalUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.DeviceTerminalUpdateRes>(
    "/api/plat/v1/device_terminal/update",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建字典数据 POST /api/plat/v1/dict_data/create */
export async function postPlatV1DictDataCreate(
  body: API.DictDataCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.DictDataCreateRes>("/api/plat/v1/dict_data/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除字典数据 GET /api/plat/v1/dict_data/delete */
export async function getPlatV1DictDataOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DictData_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.DictDataDeleteRes>("/api/plat/v1/dict_data/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取字典数据详情 GET /api/plat/v1/dict_data/detail */
export async function getPlatV1DictDataDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DictDataDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.DictDataDetailRes>("/api/plat/v1/dict_data/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取字典数据列表 GET /api/plat/v1/dict_data/list */
export async function getPlatV1DictDataList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DictDataListParams,
  options?: { [key: string]: any }
) {
  return request<API.DictDataListRes>("/api/plat/v1/dict_data/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择字典数据 GET /api/plat/v1/dict_data/select */
export async function getPlatV1DictDataSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DictDataSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.DictDataSelectRes>("/api/plat/v1/dict_data/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新字典数据 POST /api/plat/v1/dict_data/update */
export async function postPlatV1DictDataUpdate(
  body: API.DictDataUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.DictDataUpdateRes>("/api/plat/v1/dict_data/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建字典类型 POST /api/plat/v1/dict_type/create */
export async function postPlatV1DictTypeCreate(
  body: API.DictTypeCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.DictTypeCreateRes>("/api/plat/v1/dict_type/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除字典类型 GET /api/plat/v1/dict_type/delete */
export async function getPlatV1DictTypeOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DictType_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.DictTypeDeleteRes>("/api/plat/v1/dict_type/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取字典类型详情 GET /api/plat/v1/dict_type/detail */
export async function getPlatV1DictTypeDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DictTypeDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.DictTypeDetailRes>("/api/plat/v1/dict_type/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取字典类型列表 GET /api/plat/v1/dict_type/list */
export async function getPlatV1DictTypeList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DictTypeListParams,
  options?: { [key: string]: any }
) {
  return request<API.DictTypeListRes>("/api/plat/v1/dict_type/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择字典类型 GET /api/plat/v1/dict_type/select */
export async function getPlatV1DictTypeSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1DictTypeSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.DictTypeSelectRes>("/api/plat/v1/dict_type/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新字典类型 POST /api/plat/v1/dict_type/update */
export async function postPlatV1DictTypeUpdate(
  body: API.DictTypeUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.DictTypeUpdateRes>("/api/plat/v1/dict_type/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 完结工单节点 POST /api/plat/v1/event_order_node/finish */
export async function postPlatV1EventOrderNodeFinish(
  body: API.EventOrderNodeFinishReq,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderNodeFinishRes>(
    "/api/plat/v1/event_order_node/finish",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 接收工单节点 POST /api/plat/v1/event_order_node/receive */
export async function postPlatV1EventOrderNodeReceive(
  body: API.EventOrderNodeReceiveReq,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderNodeReceiveRes>(
    "/api/plat/v1/event_order_node/receive",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 退回工单节点 POST /api/plat/v1/event_order_node/return */
export async function postPlatV1EventOrderNodeOpenApiReturn(
  body: API.EventOrderNodeReturnReq,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderNodeReturnRes>(
    "/api/plat/v1/event_order_node/return",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 流转工单节点 POST /api/plat/v1/event_order_node/transfer */
export async function postPlatV1EventOrderNodeTransfer(
  body: API.EventOrderNodeTransferReq,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderNodeTransferRes>(
    "/api/plat/v1/event_order_node/transfer",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建事件工单 POST /api/plat/v1/event_order/create */
export async function postPlatV1EventOrderCreate(
  body: API.EventOrderCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderCreateRes>("/api/plat/v1/event_order/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除事件工单 GET /api/plat/v1/event_order/delete */
export async function getPlatV1EventOrderOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventOrder_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderDeleteRes>("/api/plat/v1/event_order/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取事件工单详情 GET /api/plat/v1/event_order/detail */
export async function getPlatV1EventOrderDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventOrderDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderDetailRes>("/api/plat/v1/event_order/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取事件工单列表 GET /api/plat/v1/event_order/list */
export async function getPlatV1EventOrderList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventOrderListParams,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderListRes>("/api/plat/v1/event_order/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取事件工单列表(接收人) GET /api/plat/v1/event_order/rec_list */
export async function getPlatV1EventOrderRecList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventOrderRecListParams,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderRecListRes>(
    "/api/plat/v1/event_order/rec_list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 选择事件工单 GET /api/plat/v1/event_order/select */
export async function getPlatV1EventOrderSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventOrderSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderSelectRes>("/api/plat/v1/event_order/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 工单统计信息 GET /api/plat/v1/event_order/statistics */
export async function getPlatV1EventOrderStatistics(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventOrderStatisticsParams,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderStatisticsRes>(
    "/api/plat/v1/event_order/statistics",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 更新事件工单状态 POST /api/plat/v1/event_order/status_update */
export async function postPlatV1EventOrderStatusUpdate(
  body: API.EventOrderStatusUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.EventOrderStatusUpdateRes>(
    "/api/plat/v1/event_order/status_update",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建事件接收者 POST /api/plat/v1/event_receiver/create */
export async function postPlatV1EventReceiverCreate(
  body: API.EventReceiverCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.EventReceiverCreateRes>(
    "/api/plat/v1/event_receiver/create",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除事件接收者 GET /api/plat/v1/event_receiver/delete */
export async function getPlatV1EventReceiverOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventReceiver_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.EventReceiverDeleteRes>(
    "/api/plat/v1/event_receiver/delete",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取事件接收者详情 GET /api/plat/v1/event_receiver/detail */
export async function getPlatV1EventReceiverDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventReceiverDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.EventReceiverDetailRes>(
    "/api/plat/v1/event_receiver/detail",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取事件接收者列表 GET /api/plat/v1/event_receiver/list */
export async function getPlatV1EventReceiverList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventReceiverListParams,
  options?: { [key: string]: any }
) {
  return request<API.EventReceiverListRes>("/api/plat/v1/event_receiver/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择事件接收者 GET /api/plat/v1/event_receiver/select */
export async function getPlatV1EventReceiverSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventReceiverSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.EventReceiverSelectRes>(
    "/api/plat/v1/event_receiver/select",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 更新事件接收者 POST /api/plat/v1/event_receiver/update */
export async function postPlatV1EventReceiverUpdate(
  body: API.EventReceiverUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.EventReceiverUpdateRes>(
    "/api/plat/v1/event_receiver/update",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 批量删除事件记录 POST /api/plat/v1/event_record/batch_delete */
export async function postPlatV1EventRecordBatchDelete(
  body: API.EventRecordBatchDeleteReq,
  options?: { [key: string]: any }
) {
  return request<API.EventRecordBatchDeleteRes>(
    "/api/plat/v1/event_record/batch_delete",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建事件记录 POST /api/plat/v1/event_record/create */
export async function postPlatV1EventRecordCreate(
  body: API.EventRecordCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.EventRecordCreateRes>("/api/plat/v1/event_record/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除事件记录 GET /api/plat/v1/event_record/delete */
export async function getPlatV1EventRecordOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventRecord_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.EventRecordDeleteRes>("/api/plat/v1/event_record/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取事件记录详情 GET /api/plat/v1/event_record/detail */
export async function getPlatV1EventRecordDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventRecordDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.EventRecordDetailRes>("/api/plat/v1/event_record/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取事件记录列表 GET /api/plat/v1/event_record/list */
export async function getPlatV1EventRecordList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventRecordListParams,
  options?: { [key: string]: any }
) {
  return request<API.EventRecordListRes>("/api/plat/v1/event_record/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择事件记录 GET /api/plat/v1/event_record/select */
export async function getPlatV1EventRecordSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventRecordSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.EventRecordSelectRes>("/api/plat/v1/event_record/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新事件记录 POST /api/plat/v1/event_record/update */
export async function postPlatV1EventRecordUpdate(
  body: API.EventRecordUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.EventRecordUpdateRes>("/api/plat/v1/event_record/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建预警事件类型 POST /api/plat/v1/event_type/create */
export async function postPlatV1EventTypeCreate(
  body: API.EventTypeCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.EventTypeCreateRes>("/api/plat/v1/event_type/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除预警事件类型 GET /api/plat/v1/event_type/delete */
export async function getPlatV1EventTypeOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventType_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.EventTypeDeleteRes>("/api/plat/v1/event_type/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取预警事件类型详情 GET /api/plat/v1/event_type/detail */
export async function getPlatV1EventTypeDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventTypeDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.EventTypeDetailRes>("/api/plat/v1/event_type/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取预警事件类型列表 GET /api/plat/v1/event_type/list */
export async function getPlatV1EventTypeList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventTypeListParams,
  options?: { [key: string]: any }
) {
  return request<API.EventTypeListRes>("/api/plat/v1/event_type/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择预警事件类型 GET /api/plat/v1/event_type/select */
export async function getPlatV1EventTypeSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1EventTypeSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.EventTypeSelectRes>("/api/plat/v1/event_type/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新预警事件类型 POST /api/plat/v1/event_type/update */
export async function postPlatV1EventTypeUpdate(
  body: API.EventTypeUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.EventTypeUpdateRes>("/api/plat/v1/event_type/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建国标设备通道 POST /api/plat/v1/gb_dev_chan/create */
export async function postPlatV1GbDevChanCreate(
  body: API.GbDevChanCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanCreateRes>("/api/plat/v1/gb_dev_chan/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除国标设备通道 GET /api/plat/v1/gb_dev_chan/delete */
export async function getPlatV1GbDevChanOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevChan_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanDeleteRes>("/api/plat/v1/gb_dev_chan/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取国标设备通道详情 GET /api/plat/v1/gb_dev_chan/detail */
export async function getPlatV1GbDevChanDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevChanDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanDetailRes>("/api/plat/v1/gb_dev_chan/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取国标设备通道flv流地址 GET /api/plat/v1/gb_dev_chan/flv_url */
export async function getPlatV1GbDevChanFlvUrl(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevChanFlvUrlParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanFlvUrlRes>("/api/plat/v1/gb_dev_chan/flv_url", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取国标设备通道是否正在录像 GET /api/plat/v1/gb_dev_chan/is_recording */
export async function getPlatV1GbDevChanIsRecording(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevChanIsRecordingParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanIsRecordingRes>(
    "/api/plat/v1/gb_dev_chan/is_recording",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取国标设备通道列表 GET /api/plat/v1/gb_dev_chan/list */
export async function getPlatV1GbDevChanList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevChanListParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanListRes>("/api/plat/v1/gb_dev_chan/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取国标设备通道回放地址 GET /api/plat/v1/gb_dev_chan/replay_url */
export async function getPlatV1GbDevChanReplayUrl(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevChanReplayUrlParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanReplayUrlRes>(
    "/api/plat/v1/gb_dev_chan/replay_url",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 选择国标设备通道 GET /api/plat/v1/gb_dev_chan/select */
export async function getPlatV1GbDevChanSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevChanSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanSelectRes>("/api/plat/v1/gb_dev_chan/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取国标设备通道截图 GET /api/plat/v1/gb_dev_chan/snapshot */
export async function getPlatV1GbDevChanSnapshot(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevChanSnapshotParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanSnapshotRes>(
    "/api/plat/v1/gb_dev_chan/snapshot",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 开始国标设备通道录像 POST /api/plat/v1/gb_dev_chan/start_record */
export async function postPlatV1GbDevChanStartRecord(
  body: API.GbDevChanStartRecordReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanStartRecordRes>(
    "/api/plat/v1/gb_dev_chan/start_record",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 停止国标设备通道录像 POST /api/plat/v1/gb_dev_chan/stop_record */
export async function postPlatV1GbDevChanStopRecord(
  body: API.GbDevChanStopRecordReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanStopRecordRes>(
    "/api/plat/v1/gb_dev_chan/stop_record",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 更新国标设备通道 POST /api/plat/v1/gb_dev_chan/update */
export async function postPlatV1GbDevChanUpdate(
  body: API.GbDevChanUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChanUpdateRes>("/api/plat/v1/gb_dev_chan/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改国标设备密码 POST /api/plat/v1/gb_dev/change-pwd */
export async function postPlatV1GbDevChangePwd(
  body: API.GbDevChangePwdReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevChangePwdRes>("/api/plat/v1/gb_dev/change-pwd", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建国标设备 POST /api/plat/v1/gb_dev/create */
export async function postPlatV1GbDevCreate(
  body: API.GbDevCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevCreateRes>("/api/plat/v1/gb_dev/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除国标设备 GET /api/plat/v1/gb_dev/delete */
export async function getPlatV1GbDevOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDev_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevDeleteRes>("/api/plat/v1/gb_dev/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取国标设备详情 GET /api/plat/v1/gb_dev/detail */
export async function getPlatV1GbDevDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevDetailRes>("/api/plat/v1/gb_dev/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 下发国标设备 POST /api/plat/v1/gb_dev/dispatch */
export async function postPlatV1GbDevDispatch(
  body: API.GbDevDispatchReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevDispatchRes>("/api/plat/v1/gb_dev/dispatch", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取国标设备下发信息 GET /api/plat/v1/gb_dev/dispatch-info */
export async function getPlatV1GbDevDispatchInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevDispatchInfoParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevDispatchInfoRes>(
    "/api/plat/v1/gb_dev/dispatch-info",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 回收国标设备下发 POST /api/plat/v1/gb_dev/dispatch-recall */
export async function postPlatV1GbDevDispatchRecall(
  body: API.GbDevDispatchRecallReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevDispatchRecallRes>(
    "/api/plat/v1/gb_dev/dispatch-recall",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取国标设备链接信息 GET /api/plat/v1/gb_dev/link_info */
export async function getPlatV1GbDevLinkInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevLinkInfoParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevLinkInfoRes>("/api/plat/v1/gb_dev/link_info", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取国标设备列表 GET /api/plat/v1/gb_dev/list */
export async function getPlatV1GbDevList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevListParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevListRes>("/api/plat/v1/gb_dev/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择国标设备 GET /api/plat/v1/gb_dev/select */
export async function getPlatV1GbDevSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevSelectRes>("/api/plat/v1/gb_dev/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 分享国标设备 POST /api/plat/v1/gb_dev/share */
export async function postPlatV1GbDevShare(
  body: API.GbDevShareReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevShareRes>("/api/plat/v1/gb_dev/share", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 国标设备分享信息 GET /api/plat/v1/gb_dev/share-infos */
export async function getPlatV1GbDevShareInfos(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1GbDevShareInfosParams,
  options?: { [key: string]: any }
) {
  return request<API.GbDevShareInfosRes>("/api/plat/v1/gb_dev/share-infos", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 回收国标设备分享 POST /api/plat/v1/gb_dev/share-recall */
export async function postPlatV1GbDevShareRecall(
  body: API.GbDevShareRecallReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevShareRecallRes>("/api/plat/v1/gb_dev/share-recall", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新国标设备 POST /api/plat/v1/gb_dev/update */
export async function postPlatV1GbDevUpdate(
  body: API.GbDevUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.GbDevUpdateRes>("/api/plat/v1/gb_dev/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建菜单 POST /api/plat/v1/menu/create */
export async function postPlatV1MenuCreate(
  body: API.MenuCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.MenuCreateRes>("/api/plat/v1/menu/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除菜单 GET /api/plat/v1/menu/delete */
export async function getPlatV1MenuOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1Menu_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.MenuDeleteRes>("/api/plat/v1/menu/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取菜单详情 GET /api/plat/v1/menu/detail */
export async function getPlatV1MenuDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1MenuDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.MenuDetailRes>("/api/plat/v1/menu/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取菜单列表 GET /api/plat/v1/menu/list */
export async function getPlatV1MenuList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1MenuListParams,
  options?: { [key: string]: any }
) {
  return request<API.MenuListRes>("/api/plat/v1/menu/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择菜单 GET /api/plat/v1/menu/select */
export async function getPlatV1MenuSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1MenuSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.MenuSelectRes>("/api/plat/v1/menu/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择全部菜单 GET /api/plat/v1/menu/select_all */
export async function getPlatV1MenuSelectAll(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1MenuSelectAllParams,
  options?: { [key: string]: any }
) {
  return request<API.MenuSelectAllRes>("/api/plat/v1/menu/select_all", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新菜单 POST /api/plat/v1/menu/update */
export async function postPlatV1MenuUpdate(
  body: API.MenuUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.MenuUpdateRes>("/api/plat/v1/menu/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建无认证接口 POST /api/plat/v1/noauth/create */
export async function postPlatV1NoauthCreate(
  body: API.NoAuthCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.NoAuthCreateRes>("/api/plat/v1/noauth/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除无认证接口 GET /api/plat/v1/noauth/delete */
export async function getPlatV1NoauthOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1Noauth_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.NoAuthDeleteRes>("/api/plat/v1/noauth/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取无认证接口详情 GET /api/plat/v1/noauth/detail */
export async function getPlatV1NoauthDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1NoauthDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.NoAuthDetailRes>("/api/plat/v1/noauth/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取无认证接口列表 GET /api/plat/v1/noauth/list */
export async function getPlatV1NoauthList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1NoauthListParams,
  options?: { [key: string]: any }
) {
  return request<API.NoAuthListRes>("/api/plat/v1/noauth/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择无认证接口 GET /api/plat/v1/noauth/select */
export async function getPlatV1NoauthSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1NoauthSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.NoAuthSelectRes>("/api/plat/v1/noauth/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新无认证接口 POST /api/plat/v1/noauth/update */
export async function postPlatV1NoauthUpdate(
  body: API.NoAuthUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.NoAuthUpdateRes>("/api/plat/v1/noauth/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 生成组织配置 POST /api/plat/v1/org_config/create */
export async function postPlatV1OrgConfigCreate(
  body: API.OrgConfigCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgConfigCreateRes>("/api/plat/v1/org_config/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取组织配置详情 GET /api/plat/v1/org_config/detail */
export async function getPlatV1OrgConfigDetail(options?: {
  [key: string]: any;
}) {
  return request<API.OrgConfigDetailRes>("/api/plat/v1/org_config/detail", {
    method: "GET",
    ...(options || {}),
  });
}

/** 重新生成 AK/SK POST /api/plat/v1/org_config/regen_keys */
export async function postPlatV1OrgConfigRegenKeys(
  body: API.OrgConfigRegenKeysReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgConfigRegenKeysRes>(
    "/api/plat/v1/org_config/regen_keys",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 更新组织配置 POST /api/plat/v1/org_config/update */
export async function postPlatV1OrgConfigUpdate(
  body: API.OrgConfigUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgConfigUpdateRes>("/api/plat/v1/org_config/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建部门 POST /api/plat/v1/org_dept/create */
export async function postPlatV1OrgDeptCreate(
  body: API.OrgDeptCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgDeptCreateRes>("/api/plat/v1/org_dept/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除部门 GET /api/plat/v1/org_dept/delete */
export async function getPlatV1OrgDeptOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgDept_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgDeptDeleteRes>("/api/plat/v1/org_dept/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取部门详情 GET /api/plat/v1/org_dept/detail */
export async function getPlatV1OrgDeptDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgDeptDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgDeptDetailRes>("/api/plat/v1/org_dept/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取部门列表 GET /api/plat/v1/org_dept/list */
export async function getPlatV1OrgDeptList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgDeptListParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgDeptListRes>("/api/plat/v1/org_dept/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择部门 GET /api/plat/v1/org_dept/select */
export async function getPlatV1OrgDeptSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgDeptSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgDeptSelectRes>("/api/plat/v1/org_dept/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新部门 POST /api/plat/v1/org_dept/update */
export async function postPlatV1OrgDeptUpdate(
  body: API.OrgDeptUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgDeptUpdateRes>("/api/plat/v1/org_dept/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建岗位 POST /api/plat/v1/org_post/create */
export async function postPlatV1OrgPostCreate(
  body: API.OrgPostCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgPostCreateRes>("/api/plat/v1/org_post/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除岗位 GET /api/plat/v1/org_post/delete */
export async function getPlatV1OrgPostOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgPost_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgPostDeleteRes>("/api/plat/v1/org_post/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取岗位详情 GET /api/plat/v1/org_post/detail */
export async function getPlatV1OrgPostDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgPostDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgPostDetailRes>("/api/plat/v1/org_post/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取岗位列表 GET /api/plat/v1/org_post/list */
export async function getPlatV1OrgPostList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgPostListParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgPostListRes>("/api/plat/v1/org_post/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择岗位 GET /api/plat/v1/org_post/select */
export async function getPlatV1OrgPostSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgPostSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgPostSelectRes>("/api/plat/v1/org_post/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新岗位 POST /api/plat/v1/org_post/update */
export async function postPlatV1OrgPostUpdate(
  body: API.OrgPostUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgPostUpdateRes>("/api/plat/v1/org_post/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建员工 POST /api/plat/v1/org_staff/create */
export async function postPlatV1OrgStaffCreate(
  body: API.OrgStaffCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgStaffCreateRes>("/api/plat/v1/org_staff/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除员工 GET /api/plat/v1/org_staff/delete */
export async function getPlatV1OrgStaffOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgStaff_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgStaffDeleteRes>("/api/plat/v1/org_staff/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取员工详情 GET /api/plat/v1/org_staff/detail */
export async function getPlatV1OrgStaffDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgStaffDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgStaffDetailRes>("/api/plat/v1/org_staff/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取员工列表 GET /api/plat/v1/org_staff/list */
export async function getPlatV1OrgStaffList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgStaffListParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgStaffListRes>("/api/plat/v1/org_staff/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择员工 GET /api/plat/v1/org_staff/select */
export async function getPlatV1OrgStaffSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgStaffSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgStaffSelectRes>("/api/plat/v1/org_staff/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新员工 POST /api/plat/v1/org_staff/update */
export async function postPlatV1OrgStaffUpdate(
  body: API.OrgStaffUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgStaffUpdateRes>("/api/plat/v1/org_staff/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建组织 POST /api/plat/v1/org/create */
export async function postPlatV1OrgCreate(
  body: API.OrgCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgCreateRes>("/api/plat/v1/org/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除组织 GET /api/plat/v1/org/delete */
export async function getPlatV1OrgOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1Org_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgDeleteRes>("/api/plat/v1/org/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取组织详情 GET /api/plat/v1/org/detail */
export async function getPlatV1OrgDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgDetailRes>("/api/plat/v1/org/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取组织列表 GET /api/plat/v1/org/list */
export async function getPlatV1OrgList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgListParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgListRes>("/api/plat/v1/org/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择组织 GET /api/plat/v1/org/select */
export async function getPlatV1OrgSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1OrgSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.OrgSelectRes>("/api/plat/v1/org/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新组织 POST /api/plat/v1/org/update */
export async function postPlatV1OrgUpdate(
  body: API.OrgUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.OrgUpdateRes>("/api/plat/v1/org/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量删除资源文件 POST /api/plat/v1/resource/batch-delete */
export async function postPlatV1ResourceBatchDelete(
  body: API.ResourceBatchDeleteReq,
  options?: { [key: string]: any }
) {
  return request<API.ResourceBatchDeleteRes>(
    "/api/plat/v1/resource/batch-delete",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除资源文件 GET /api/plat/v1/resource/delete */
export async function getPlatV1ResourceOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1Resource_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.ResourceDeleteRes>("/api/plat/v1/resource/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取资源文件详情 GET /api/plat/v1/resource/detail */
export async function getPlatV1ResourceDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1ResourceDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.ResourceDetailRes>("/api/plat/v1/resource/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取资源文件列表 GET /api/plat/v1/resource/list */
export async function getPlatV1ResourceList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1ResourceListParams,
  options?: { [key: string]: any }
) {
  return request<API.ResourceListRes>("/api/plat/v1/resource/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择资源文件 GET /api/plat/v1/resource/select */
export async function getPlatV1ResourceSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1ResourceSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.ResourceSelectRes>("/api/plat/v1/resource/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 上传资源文件 POST /api/plat/v1/resource/upload */
export async function postPlatV1ResourceUpload(
  body: API.ResourceUploadReq,
  options?: { [key: string]: any }
) {
  const formData = new FormData();

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele];

    if (item !== undefined && item !== null) {
      if (typeof item === "object" && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ""));
        } else {
          formData.append(
            ele,
            new Blob([JSON.stringify(item)], { type: "application/json" })
          );
        }
      } else {
        formData.append(ele, item);
      }
    }
  });

  return request<API.ResourceUploadRes>("/api/plat/v1/resource/upload", {
    method: "POST",
    data: formData,
    requestType: "form",
    ...(options || {}),
  });
}

/** 角色菜单关系 GET /api/plat/v1/role_menu/items */
export async function getPlatV1RoleMenuItems(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1RoleMenuItemsParams,
  options?: { [key: string]: any }
) {
  return request<API.RoleMenuItemsRes>("/api/plat/v1/role_menu/items", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 角色菜单关系变更 POST /api/plat/v1/role_menu/update */
export async function postPlatV1RoleMenuUpdate(
  body: API.RoleMenuUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.RoleMenuUpdateRes>("/api/plat/v1/role_menu/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建角色 POST /api/plat/v1/role/create */
export async function postPlatV1RoleCreate(
  body: API.RoleCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.RoleCreateRes>("/api/plat/v1/role/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除角色 GET /api/plat/v1/role/delete */
export async function getPlatV1RoleOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1Role_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.RoleDeleteRes>("/api/plat/v1/role/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取角色详情 GET /api/plat/v1/role/detail */
export async function getPlatV1RoleDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1RoleDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.RoleDetailRes>("/api/plat/v1/role/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取角色列表 GET /api/plat/v1/role/list */
export async function getPlatV1RoleList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1RoleListParams,
  options?: { [key: string]: any }
) {
  return request<API.RoleListRes>("/api/plat/v1/role/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择角色 GET /api/plat/v1/role/select */
export async function getPlatV1RoleSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1RoleSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.RoleSelectRes>("/api/plat/v1/role/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新角色 POST /api/plat/v1/role/update */
export async function postPlatV1RoleUpdate(
  body: API.RoleUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.RoleUpdateRes>("/api/plat/v1/role/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建系统配置 POST /api/plat/v1/sys_config/create */
export async function postPlatV1SysConfigCreate(
  body: API.SysConfigCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.SysConfigCreateRes>("/api/plat/v1/sys_config/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除系统配置 GET /api/plat/v1/sys_config/delete */
export async function getPlatV1SysConfigOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1SysConfig_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.SysConfigDeleteRes>("/api/plat/v1/sys_config/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取系统配置详情 GET /api/plat/v1/sys_config/detail */
export async function getPlatV1SysConfigDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1SysConfigDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.SysConfigDetailRes>("/api/plat/v1/sys_config/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取系统配置列表 GET /api/plat/v1/sys_config/list */
export async function getPlatV1SysConfigList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1SysConfigListParams,
  options?: { [key: string]: any }
) {
  return request<API.SysConfigListRes>("/api/plat/v1/sys_config/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 选择系统配置 GET /api/plat/v1/sys_config/select */
export async function getPlatV1SysConfigSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1SysConfigSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.SysConfigSelectRes>("/api/plat/v1/sys_config/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新系统配置 POST /api/plat/v1/sys_config/update */
export async function postPlatV1SysConfigUpdate(
  body: API.SysConfigUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.SysConfigUpdateRes>("/api/plat/v1/sys_config/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建用户 POST /api/plat/v1/user/create */
export async function postPlatV1UserCreate(
  body: API.UserCreateReq,
  options?: { [key: string]: any }
) {
  return request<API.UserCreateRes>("/api/plat/v1/user/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除用户 GET /api/plat/v1/user/delete */
export async function getPlatV1UserOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1User_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.UserDeleteRes>("/api/plat/v1/user/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户详情 GET /api/plat/v1/user/detail */
export async function getPlatV1UserDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1UserDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.UserDetailRes>("/api/plat/v1/user/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户列表 GET /api/plat/v1/user/list */
export async function getPlatV1UserList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1UserListParams,
  options?: { [key: string]: any }
) {
  return request<API.UserListRes>("/api/plat/v1/user/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 重置用户密码 POST /api/plat/v1/user/reset-pwd */
export async function postPlatV1UserResetPwd(
  body: API.UserResetPwdReq,
  options?: { [key: string]: any }
) {
  return request<API.UserResetPwdRes>("/api/plat/v1/user/reset-pwd", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 选择用户 GET /api/plat/v1/user/select */
export async function getPlatV1UserSelect(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1UserSelectParams,
  options?: { [key: string]: any }
) {
  return request<API.UserSelectRes>("/api/plat/v1/user/select", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新用户 POST /api/plat/v1/user/update */
export async function postPlatV1UserUpdate(
  body: API.UserUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.UserUpdateRes>("/api/plat/v1/user/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量删除视频文件 POST /api/plat/v1/video_file/batch_delete */
export async function postPlatV1VideoFileBatchDelete(
  body: API.VideoFileBatchDeleteReq,
  options?: { [key: string]: any }
) {
  return request<API.VideoFileBatchDeleteRes>(
    "/api/plat/v1/video_file/batch_delete",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除视频文件 GET /api/plat/v1/video_file/delete */
export async function getPlatV1VideoFileOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1VideoFile_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.VideoFileDeleteRes>("/api/plat/v1/video_file/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取视频文件详情 GET /api/plat/v1/video_file/detail */
export async function getPlatV1VideoFileDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1VideoFileDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.VideoFileDetailRes>("/api/plat/v1/video_file/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取视频文件列表 GET /api/plat/v1/video_file/list */
export async function getPlatV1VideoFileList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1VideoFileListParams,
  options?: { [key: string]: any }
) {
  return request<API.VideoFileListRes>("/api/plat/v1/video_file/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 批量删除录制记录 POST /api/plat/v1/video_record/batch_delete */
export async function postPlatV1VideoRecordBatchDelete(
  body: API.VideoRecordBatchDeleteReq,
  options?: { [key: string]: any }
) {
  return request<API.VideoRecordBatchDeleteRes>(
    "/api/plat/v1/video_record/batch_delete",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除录制记录 GET /api/plat/v1/video_record/delete */
export async function getPlatV1VideoRecordOpenApiDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1VideoRecord_openAPI_deleteParams,
  options?: { [key: string]: any }
) {
  return request<API.VideoRecordDeleteRes>("/api/plat/v1/video_record/delete", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取录制记录详情 GET /api/plat/v1/video_record/detail */
export async function getPlatV1VideoRecordDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1VideoRecordDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.VideoRecordDetailRes>("/api/plat/v1/video_record/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取录制记录列表 GET /api/plat/v1/video_record/list */
export async function getPlatV1VideoRecordList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPlatV1VideoRecordListParams,
  options?: { [key: string]: any }
) {
  return request<API.VideoRecordListRes>("/api/plat/v1/video_record/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 下载资源文件 GET /api/resource/v1/${orgId}/${group}/${fileName} */
export async function getResourceV1OrgIdGroupFileName(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getResourceV1OrgIdGroupFileNameParams,
  options?: { [key: string]: any }
) {
  return request<API.ResourceDownloadRes>(
    `/api/resource/v1/${orgId}/${group}/${fileName}`,
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}
